import { render, staticRenderFns } from "./alterationAddModal.vue?vue&type=template&id=0929578e&scoped=true&"
import script from "./alterationAddModal.vue?vue&type=script&lang=ts&"
export * from "./alterationAddModal.vue?vue&type=script&lang=ts&"
import style0 from "./alterationAddModal.vue?vue&type=style&index=0&id=0929578e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0929578e",
  null
  
)

export default component.exports